export enum MobileLengthPerCode {
  Default = 7,

  // Saudi Arabia
  '+966' = 9,

  // Egypt
  '+20' = 10,

  // UAE
  '+971' = 9,

  // Kuwait
  '+965' = 8,

  // Qatar
  '+974' = 8,

  // Bahrain
  '+973' = 8,

  // Oman
  '+968' = 8,

  // Yemen
  '+967' = 9,

  // Iraq
  '+964' = 10,

  // Syria
  '+963' = 9,

  // Lebanon
  '+961' = 8,

  // Jordan
  '+962' = 9,

  // Palestine
  '+970' = 9,

  // Spain
  '+34' = 9,

  // Pakistan
  '+92' = 10,

  // Nepal
  '+977' = 10,

  // Libya
  '+218' = 9,

  // India
  '+91' = 10,

  // Bangladesh
  '+880' = 10,

  // Turkey
  '+90' = 10,

  // Morocco
  '+212' = 9,

  //Iran
  '+98' = 10,
}
